/**
* Testimonial Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonial Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'testimonial-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.testimonial-slider' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--testimonial-slider' )[0], {
          type: 'loop',
          pagination: false,
          arrows: true,
          gap: '32px',
          autoWidth: false,
          perPage: 2,
          direction: window.isRtl ? 'rtl' : 'ltr',
          breakpoints: {
            640: {
              perPage: 1,
              autoWidth: false,
            },
          },
        } );

        splide.mount();

        splide.on( 'overflow', function( isOverflow ) {
          splide.options = {
            arrows: isOverflow,
            drag: isOverflow,
          };
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'testimonial-slider', COMPONENT );
} )( app );
